import { render, staticRenderFns } from "./inscription-list-table.vue?vue&type=template&id=350a8304&"
import script from "./inscription-list-table.vue?vue&type=script&lang=js&"
export * from "./inscription-list-table.vue?vue&type=script&lang=js&"
import style0 from "./inscription-list-table.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports